module.exports = __webpack_public_path__ + "media/product/menu-image-d211013e.png";